import React from 'react';
import { Link } from 'gatsby';

const Copyright = ({
  copyright
}) => {
  const madeBy = copyright.madeByName ? /*#__PURE__*/React.createElement("div", {
    className: "footer__right"
  }, /*#__PURE__*/React.createElement("a", {
    href: copyright.madeByLink,
    className: "main-menu__link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, copyright.madeByName, " ", /*#__PURE__*/React.createElement("sup", null, "\xAE"))) : '';
  return /*#__PURE__*/React.createElement("footer", {
    className: "footer__container footer__meta"
  }, /*#__PURE__*/React.createElement("div", {
    className: "footer__left"
  }, "\xA9 ", new Date().getFullYear(), " ", copyright.siteName, /*#__PURE__*/React.createElement("sup", null, "\u2122")), madeBy);
};

Copyright.displayName = 'Copyright';
export default Copyright;